
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[productId]",
      function () {
        return require("private-next-pages/products/[productId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[productId]"])
      });
    }
  